import { Colors } from 'src/com/sixdee/crbtportal/utils/resources/colors';
import { Fonts } from 'src/com/sixdee/crbtportal/utils/resources/fonts';
import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../toolkit/uicomponentcss';

export interface NameTuneBuyCSSStyle extends UIComponentCSSStyle
{
    getContactNumberCSSStyle(): object;
    getVerifyNumberButtonCSSStyle(): object;
    getRowDivCSSStyle(): object ;
    getTermsConditionCSSStyle():object;
    getMobileNumberCSSStyle(): object;
    getAnchorCSSStyle(): object;
}

export class NameTuneBuyCSSStyleImpl extends UIComponentCSSStyleImpl implements NameTuneBuyCSSStyle
{
    getMobileNumberCSSStyle(): object 
    {
        return {
            marginTop: "40px",
            marginLeft:'31.5px',
            marginRight:'31.5px'
        };
    }
    getTermsConditionCSSStyle(): object {
        return{
            display: "inline-block",
            // textAlign: this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ? "left" : "right",
            height: "20px",
            letterSpacing: 0,
            fontSize: this.getResources().getFont(Fonts.h7),
            color:'#231F20',
            fontWeight:'500',
            fontFamily:this.getResources().getFontFamily(),
            lineHeight: "20px",
            paddingLeft: "10px",
            // flex: 2,
            // paddingTop:'5px',
            // marginLeft:'5px',
        };
    }

    getAnchorCSSStyle(): object {
        return {
                    lineHeight: '20px', 
                    letterSpacing: "-0.08px",
                    fontFamily: this.getResources().getFontFamily(), 
                    fontSize: this.getResources().getFont(Fonts.h6), 
                    color: this.getResources().getColor(Colors.color_7), 
                };
    }
    getWrapperCSSStyle(): object
    {
        return {
            height: "auto",
            width: "100%",
            borderRadius: "8px",
            paddingBottom:'30px',
            backgroundColor: this.getResources().getColor(Colors.color_5),
        };
    }

    getContactNumberCSSStyle(): object 
    {
        return {
            width: "100%",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            paddingTop: "0px",
            paddingLeft: "32px",
            paddingRight: "32px",
        };
    }

    getRowDivCSSStyle(): object 
    {
        return {
            marginTop: "20px",
            display: "flex",
            width:'100%',
            justifyContent:'center',
            position: "relative",
            alignItems:'center',
            flexDirection:"row",
            flexFlow: "row wrap",
        };
    }

    getVerifyNumberButtonCSSStyle(): object 
    {
        return {
            marginTop: "30px",
            width:'180px',
            height: "40px",
            marginLeft: "auto",
            marginRight: "auto",
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/popup/nametune/nametunebuycss.tsx